var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0002 28.75C31.5484 28.75 28.7502 31.5482 28.7502 35C28.7502 38.4517 31.5484 41.25 35.0002 41.25C38.4519 41.25 41.2502 38.4517 41.2502 35C41.2502 31.5482 38.4519 28.75 35.0002 28.75ZM31.2502 35C31.2502 32.9289 32.9291 31.25 35.0002 31.25C37.0712 31.25 38.7502 32.9289 38.7502 35C38.7502 37.071 37.0712 38.75 35.0002 38.75C32.9291 38.75 31.2502 37.071 31.2502 35Z",
    fill: "url(#paint0_linear_255_757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0002 20.4166C27.4766 20.4166 22.409 24.9236 19.4678 28.7447L19.4147 28.8136C18.7496 29.6775 18.1369 30.4732 17.7213 31.414C17.2762 32.4214 17.0835 33.5194 17.0835 35C17.0835 36.4805 17.2762 37.5785 17.7213 38.586C18.1369 39.5268 18.7496 40.3224 19.4147 41.1863L19.4678 41.2552C22.409 45.0763 27.4766 49.5833 35.0002 49.5833C42.5237 49.5833 47.5913 45.0763 50.5326 41.2552L50.5856 41.1863C51.2507 40.3224 51.8634 39.5268 52.279 38.586C52.7241 37.5785 52.9168 36.4805 52.9168 35C52.9168 33.5194 52.7241 32.4214 52.279 31.414C51.8634 30.4731 51.2508 29.6775 50.5856 28.8136L50.5326 28.7447C47.5913 24.9236 42.5237 20.4166 35.0002 20.4166ZM21.4489 30.2696C24.1646 26.7415 28.5841 22.9166 35.0002 22.9166C41.4162 22.9166 45.8358 26.7415 48.5515 30.2696C49.2824 31.2193 49.7106 31.7867 49.9922 32.4242C50.2554 33.02 50.4168 33.7482 50.4168 35C50.4168 36.2517 50.2554 36.9799 49.9922 37.5757C49.7106 38.2132 49.2824 38.7806 48.5515 39.7303C45.8358 43.2584 41.4162 47.0833 35.0002 47.0833C28.5841 47.0833 24.1646 43.2584 21.4489 39.7303C20.7179 38.7806 20.2897 38.2132 20.0081 37.5757C19.7449 36.9799 19.5835 36.2517 19.5835 35C19.5835 33.7482 19.7449 33.02 20.0081 32.4242C20.2897 31.7867 20.7179 31.2193 21.4489 30.2696Z",
    fill: "url(#paint1_linear_255_757)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_757",
    x1: 35.0002,
    y1: 20.4166,
    x2: 35.0002,
    y2: 49.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_757",
    x1: 35.0002,
    y1: 20.4166,
    x2: 35.0002,
    y2: 49.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx2);
export default __webpack_public_path__ + "static/media/ex2.40224298d52f3698893f8a2410066b92.svg";
export { ForwardRef as ReactComponent };